import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { compose, withHandlers, withProps, withStateHandlers, lifecycle } from 'recompose';
import { scroller } from 'react-scroll';
import { generateNoteLink } from "../../../util/common";
import { formatDateTime } from "../../../util/datetime";
import { copyToClipboard } from '@applyboard/ui-utils';
import sweetAlertConfirm from "../../enhancers/sweetAlertEnhancer";
import raiseSuccessMessage from "../../../util/raiseSuccessMessage";
var generateTooltip = function generateTooltip(note) {
  if (!note || !note.read_history) return null;
  if (note.author && !note.author.staff) return null;
  if (!note.read_history.agent || !note.read_history.student) return null;
  return [note.read_history.agent, note.read_history.student];
};
var enhancer = compose(withProps(function (_ref) {
  var _note$attachments, _note$author;
  var note = _ref.note,
    userPermissions = _ref.userPermissions;
  return {
    batchSendPermission: userPermissions && userPermissions.bulk_create_public_note,
    deletePermission: note && note.permissions && note.permissions.destroy,
    displayAttachments: !!(note !== null && note !== void 0 && (_note$attachments = note.attachments) !== null && _note$attachments !== void 0 && _note$attachments.length),
    isInternal: note && note.author.staff || false,
    isPrivate: note && note.visibility === 'private',
    noteCreatedAt: note && formatDateTime(note.created_at, 'MMMM Do YYYY, HH:mm'),
    noteUrl: generateNoteLink(note.id),
    readInfo: (note === null || note === void 0 ? void 0 : note.read_history) && (note !== null && note !== void 0 && (_note$author = note.author) !== null && _note$author !== void 0 && _note$author.staff ? note.read_history.agent || note.read_history.student : note.read_history.applyboard_staff) || null,
    readTooltip: generateTooltip(note)
  };
}), withStateHandlers({
  scrollNoteId: null
}, {
  setNoteId: function setNoteId() {
    return function (scrollNoteId) {
      scroller.scrollTo('NotesListingContainer', {
        duration: 0,
        delay: 0,
        smooth: 'easeInOutQuint'
      });
      scroller.scrollTo("note-".concat(scrollNoteId), {
        duration: 800,
        offset: -400,
        smooth: 'easeInOutQuint',
        containerId: 'NotesListingContainer'
      });
      return {
        scrollNoteId: scrollNoteId
      };
    };
  }
}), withHandlers({
  onDelete: function onDelete(_ref2) {
    var _onDelete = _ref2.onDelete,
      note = _ref2.note;
    return function () {
      _onDelete(note.id);
    };
  },
  onReply: function onReply(_ref3) {
    var _onReply = _ref3.onReply,
      note = _ref3.note;
    return function () {
      _onReply(note);
    };
  },
  onCopyToClipboard: function onCopyToClipboard(_ref4) {
    var noteUrl = _ref4.noteUrl;
    return function () {
      copyToClipboard(noteUrl).then(function (isSuccess) {
        if (isSuccess) {
          raiseSuccessMessage("Copied note's link to clipboard");
        }
      });
    };
  },
  onBatchSend: function onBatchSend(_ref5) {
    var note = _ref5.note,
      _onBatchSend = _ref5.onBatchSend;
    return function () {
      _onBatchSend(note);
    };
  }
}), lifecycle({
  componentWillMount: function componentWillMount() {
    var searchParameter = this.props.searchParameters() || null;
    var scrollNoteId = searchParameter && searchParameter.note_id ? searchParameter.note_id.replace(/-/) : null;
    if (scrollNoteId) {
      this.props.setNoteId(scrollNoteId);
    }
  }
}), sweetAlertConfirm('onDelete'));
export default enhancer;